import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControlledOptionsFilter } from '@vlabs/monokit/shared/ui/controlled-options-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';

function BackpackFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useWorkspaceFilters();
  const selectedOptions = filters.backpack_states ?? [];
  const options = EVENT_ENUMS.ACCESSORIES.BACKPACK.raw as Option[];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedOptions.length === 0}
      onClickReset={() => updateFilters({ backpack_states: undefined })}
      ref={ref}
    >
      <ControlledOptionsFilter
        name="backpack_states"
        onChange={(backpackStates) => updateFilters({
          backpack_states: backpackStates.length > 0 ? backpackStates : undefined,
        })}
        options={options}
        value={selectedOptions}
      />
    </PopoverWithButton>
  );
}

const BackpackFilterPopoverWithRef = forwardRef(BackpackFilterPopover);
export { BackpackFilterPopoverWithRef as BackpackFilterPopover };
